import {interpolate} from "@straylightagency/utils/string";
import {get} from "@straylightagency/utils/object";

let localizedStrings = {};

export function loadLocalizedStringsFrom(object) {
    localizedStrings = Object.assign( localizedStrings, object );
}

export function __(placeholder, data = {}) {
    const label = get( localizedStrings, placeholder ) ?? placeholder;

    if ( typeof label === 'string' ) {
        return interpolate( label, data );
    }

    return label;
}